import i18next from 'i18next'

import avalancheIcon from 'assets/landing-images/chains/avalanche.png'
import avalancheIcon2x from 'assets/landing-images/chains/avalanche@2x.png'
import bnbChainIcon from 'assets/landing-images/chains/bnb-chain.png'
import bnbChainIcon2x from 'assets/landing-images/chains/bnb-chain@2x.png'
import ethereumIcon from 'assets/landing-images/chains/ethereum.png'
import ethereumIcon2x from 'assets/landing-images/chains/ethereum@2x.png'
import hecoIcon from 'assets/landing-images/chains/heco.png'
import hecoIcon2x from 'assets/landing-images/chains/heco@2x.png'
import iotexIcon from 'assets/landing-images/chains/iotex.png'
import iotexIcon2x from 'assets/landing-images/chains/iotex@2x.png'
import okexIcon from 'assets/landing-images/chains/okex.png'
import okexIcon2x from 'assets/landing-images/chains/okex@2x.png'
import polygonIcon from 'assets/landing-images/chains/polygon.png'
import polygonIcon2x from 'assets/landing-images/chains/polygon@2x.png'
import solanaIcon from 'assets/landing-images/chains/solana.png'
import solanaIcon2x from 'assets/landing-images/chains/solana@2x.png'
// ==
import avalanchePartnerIcon from 'assets/landing-images/partners/avalanche.png'
import avalanchePartnerIcon2x from 'assets/landing-images/partners/avalanche@2x.png'
import bnbChainPartnerIcon from 'assets/landing-images/partners/bnb-chain.png'
import bnbChainPartnerIcon2x from 'assets/landing-images/partners/bnb-chain@2x.png'
import bscNewsPartnerIcon from 'assets/landing-images/partners/bsc-news.png'
import bscNewsPartnerIcon2x from 'assets/landing-images/partners/bsc-news@2x.png'
import chainlinkPartnerIcon from 'assets/landing-images/partners/chainlink.png'
import chainlinkPartnerIcon2x from 'assets/landing-images/partners/chainlink@2x.png'
import diaPartnerIcon from 'assets/landing-images/partners/dia.png'
import diaPartnerIcon2x from 'assets/landing-images/partners/dia@2x.png'
import factblockPartnerIcon from 'assets/landing-images/partners/factblock.png'
import factblockPartnerIcon2x from 'assets/landing-images/partners/factblock@2x.png'
import hackenPartnerIcon from 'assets/landing-images/partners/hacken.png'
import hackenPartnerIcon2x from 'assets/landing-images/partners/hacken@2x.png'
import hecoPartnerIcon from 'assets/landing-images/partners/heco.png'
import hecoPartnerIcon2x from 'assets/landing-images/partners/heco@2x.png'
import hotbitPartnerIcon from 'assets/landing-images/partners/hotbit.png'
import hotbitPartnerIcon2x from 'assets/landing-images/partners/hotbit@2x.png'
import iotexPartnerIcon from 'assets/landing-images/partners/iotex.png'
import iotexPartnerIcon2x from 'assets/landing-images/partners/iotex@2x.png'
import mdexPartnerIcon from 'assets/landing-images/partners/mdex.png'
import mdexPartnerIcon2x from 'assets/landing-images/partners/mdex@2x.png'
import mechanismCapitalPartnerIcon from 'assets/landing-images/partners/mechanism-capital.png'
import mechanismCapitalPartnerIcon2x from 'assets/landing-images/partners/mechanism-capital@2x.png'
import metisPartnerIcon from 'assets/landing-images/partners/metis.png'
import metisPartnerIcon2x from 'assets/landing-images/partners/metis@2x.png'
import mimoPartnerIcon from 'assets/landing-images/partners/mimo.png'
import mimoPartnerIcon2x from 'assets/landing-images/partners/mimo@2x.png'
import pangolinPartnerIcon from 'assets/landing-images/partners/pangolin.png'
import pangolinPartnerIcon2x from 'assets/landing-images/partners/pangolin@2x.png'
import polygonPartnerIcon from 'assets/landing-images/partners/polygon.png'
import polygonPartnerIcon2x from 'assets/landing-images/partners/polygon@2x.png'
import quickswapPartnerIcon from 'assets/landing-images/partners/quickswap.png'
import quickswapPartnerIcon2x from 'assets/landing-images/partners/quickswap@2x.png'
import zeePartnerIcon from 'assets/landing-images/partners/zee-prime-capital.png'
import zeePartnerIcon2x from 'assets/landing-images/partners/zee-prime-capital@2x.png'
// ==
import smileyForDevelopers from 'assets/landing-images/smiles/smiley-for-developers.png'
import smileyForLiquidityProviders from 'assets/landing-images/smiles/smiley-for-liquidity-providers.png'
import smileyForTraders from 'assets/landing-images/smiles/smiley-for-traders.png'
import smileyGovernance from 'assets/landing-images/smiles/smiley-governance.png'

export const chainsData = {
  ethereum: {
    icon: ethereumIcon,
    icon2x: ethereumIcon2x,
    alt: 'Ethereum'
  },
  solana: {
    icon: solanaIcon,
    icon2x: solanaIcon2x,
    alt: 'Solana'
  },
  bnbChain: {
    icon: bnbChainIcon,
    icon2x: bnbChainIcon2x,
    alt: 'BNB Chain'
  },
  polygon: {
    icon: polygonIcon,
    icon2x: polygonIcon2x,
    alt: 'Polygon'
  },
  avalanche: {
    icon: avalancheIcon,
    icon2x: avalancheIcon2x,
    alt: 'Avalanche'
  },
  heco: {
    icon: hecoIcon,
    icon2x: hecoIcon2x,
    alt: 'HECO Chain (Heco)'
  },
  iotex: {
    icon: iotexIcon,
    icon2x: iotexIcon2x,
    alt: 'IoTeX'
  },
  okex: {
    icon: okexIcon,
    icon2x: okexIcon2x,
    alt: 'okex'
  }
}

const t = i18next.t.bind(i18next)

export const countsCards = [
  { count: '$15m+', text: t('All time Trading volume') },
  { count: '200+', text: t('Tokens') },
  { count: '5x', text: t('Trading leverage') },
  { count: '$5.35m', text: t('Current TVL') }
]

export const architectureCards = [
  {
    title: t('For Traders'),
    icon: smileyForTraders,
    alt: t('WOWswap for traders'),
    text: t('Securely swap between crypto assets')
  },
  {
    title: t('For Liquidity Providers'),
    icon: smileyForLiquidityProviders,
    alt: t('WOWswap for liquidity providers'),
    text: t('Earn yield from transaction fees and liquidity incentives.')
  },
  {
    title: t('For Developers'),
    icon: smileyForDevelopers,
    alt: t('WOWswap for Developers'),
    text: t('As a core DeFi building block WOWswap')
  },
  {
    title: t('Governance'),
    icon: smileyGovernance,
    alt: t('WOWswap Governance token'),
    text: t('Decide the path for the future of financial services')
  }
]

export const partnersData = {
  mechanismCapital: {
    icon: mechanismCapitalPartnerIcon,
    icon2x: mechanismCapitalPartnerIcon2x,
    alt: 'Mechanism capital'
  },
  polygon: {
    icon: polygonPartnerIcon,
    icon2x: polygonPartnerIcon2x,
    alt: 'Polygon'
  },
  quickswap: {
    icon: quickswapPartnerIcon,
    icon2x: quickswapPartnerIcon2x,
    alt: 'QuickSwap'
  },
  factblock: {
    icon: factblockPartnerIcon,
    icon2x: factblockPartnerIcon2x,
    alt: 'Factblock'
  },
  bnbChain: {
    icon: bnbChainPartnerIcon,
    icon2x: bnbChainPartnerIcon2x,
    alt: 'BNB Chain'
  },
  hotbit: {
    icon: hotbitPartnerIcon,
    icon2x: hotbitPartnerIcon2x,
    alt: 'HotBit'
  },
  avalanche: {
    icon: avalanchePartnerIcon,
    icon2x: avalanchePartnerIcon2x,
    alt: 'avalanche'
  },
  pangolin: {
    icon: pangolinPartnerIcon,
    icon2x: pangolinPartnerIcon2x,
    alt: 'pangolin'
  },
  chainlink: {
    icon: chainlinkPartnerIcon,
    icon2x: chainlinkPartnerIcon2x,
    alt: 'chainlink'
  },
  iotex: {
    icon: iotexPartnerIcon,
    icon2x: iotexPartnerIcon2x,
    alt: 'IoTeX'
  },
  heco: {
    icon: hecoPartnerIcon,
    icon2x: hecoPartnerIcon2x,
    alt: 'HECO Chain (Heco)'
  },
  mdex: {
    icon: mdexPartnerIcon,
    icon2x: mdexPartnerIcon2x,
    alt: 'mdex.com'
  },
  dia: {
    icon: diaPartnerIcon,
    icon2x: diaPartnerIcon2x,
    alt: 'DIA (Decentralized Information Asset)'
  },
  bscNews: {
    icon: bscNewsPartnerIcon,
    icon2x: bscNewsPartnerIcon2x,
    alt: 'bsc news'
  },
  hacken: {
    icon: hackenPartnerIcon,
    icon2x: hackenPartnerIcon2x,
    alt: 'Hacken'
  },
  metis: {
    icon: metisPartnerIcon,
    icon2x: metisPartnerIcon2x,
    alt: 'METIS'
  },
  mimo: {
    icon: mimoPartnerIcon,
    icon2x: mimoPartnerIcon2x,
    alt: 'mimo'
  },
  zee: {
    icon: zeePartnerIcon,
    icon2x: zeePartnerIcon2x,
    alt: 'zee prime capital'
  }
}
